import React from "react";

const Header = () => {
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-slate-500/20 bg-primary/85 backdrop-blur">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-5 py-4 text-slate-100 md:px-8">
        <a href="/#home" className="heading-font text-lg font-bold tracking-wide text-accent md:text-xl">
          Jeffrey Lau
        </a>
        <nav className="hidden items-center gap-8 text-sm font-semibold uppercase tracking-[0.14em] text-slate-300 md:flex">
          <a href="/#about" className="hover:text-accent">
            About
          </a>
          <a href="/#contact" className="hover:text-accent">
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
